<template>
  <div class="scoring-panel" :style="{ width: panelWidth + 'px' }">
    <div class="resize-handle" @mousedown="startResize"></div>
    <div class="content">
      <button class="close-btn" @click="closePage">X</button>

      <h1>Scoring Sheet</h1>
      
      <div class="trails-container">
        <ScoreSection 
          taskName="Trails" 
          route="/trail-making/a"
          :currentRoute="currentRoute"
          class="trails-section"
        >
          <div class="trail-making-layout">
            <div class="trail-section">
              <div class="trail-header">A:</div>
              <div class="trail-scores">
                <div class="trail-score-item">
                  <div class="score-box">{{ jsonData && jsonData.trailMakingA ? (jsonData.trailMakingA.time || 0) : 0 }}</div>
                  <div class="score-label">Time (s)</div>
                </div>
                <div class="trail-score-item">
                  <div class="score-box">{{ jsonData && jsonData.trailMakingA ? (jsonData.trailMakingA.errors || 0) : 0 }}</div>
                  <div class="score-label">Errors</div>
                </div>
              </div>
            </div>
            <div class="trail-section">
              <div class="trail-header">B:</div>
              <div class="trail-scores">
                <div class="trail-score-item">
                  <div class="score-box">{{ jsonData && jsonData.trailMakingB ? (jsonData.trailMakingB.time || 0) : 0 }}</div>
                  <div class="score-label">Time (s)</div>
                </div>
                <div class="trail-score-item">
                  <div class="score-box">{{ jsonData && jsonData.trailMakingB ? (jsonData.trailMakingB.errors || 0) : 0 }}</div>
                  <div class="score-label">Errors</div>
                </div>
              </div>
            </div>
          </div>
        </ScoreSection>

        <div class="info-box">
          <div class="info-row">
            <span class="info-label">Char ID:</span>
            <span class="info-value">{{ charId || '—' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Date:</span>
            <span class="info-value">{{ todayDate || '—' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Visit No.:</span>
            <span class="info-value">—</span>
          </div>
          <div class="info-row">
            <span class="info-label">Visit Type:</span>
            <span class="info-value">Biennial</span>
          </div>
          <div class="info-row">
            <span class="info-label">Interviewer:</span>
            <span class="info-value">{{ interviewerName || '—' }}</span>
          </div>
        </div>
      </div>


      <div v-if="showAdvancedTasks">
        <ScoreSection 
          taskName="CONST. PRAXIS" 
          :isDisabled="true"
        >
          <div class="const-praxis-content">
            <div class="const-praxis-section">
              <div class="const-praxis-label">INITIAL:</div>
              <div class="const-praxis-items">
                <div class="const-praxis-item">
                  <span class="item-number">1.</span>
                  <input type="text" class="const-input" />
                  <span class="const-shape-label">Circle</span>
                  <span class="const-score-placeholder">2</span>
                </div>
                <div class="const-praxis-item">
                  <span class="item-number">2.</span>
                  <input type="text" class="const-input" />
                  <span class="const-shape-label">Diamond</span>
                  <span class="const-score-placeholder">3</span>
                </div>
                <div class="const-praxis-item">
                  <span class="item-number">3.</span>
                  <input type="text" class="const-input" />
                  <span class="const-shape-label">Rectangle</span>
                  <span class="const-score-placeholder">2</span>
                </div>
                <div class="const-praxis-item">
                  <span class="item-number">4.</span>
                  <input type="text" class="const-input" />
                  <span class="const-shape-label">Cube</span>
                  <span class="const-score-placeholder">4</span>
                </div>
              </div>
            </div>
            <div class="const-praxis-section">
              <div class="const-praxis-label">RECALL:</div>
              <div class="const-praxis-items">
                <div class="const-praxis-item">
                  <span class="item-number">1.</span>
                  <input type="text" class="const-input" />
                  <span class="const-shape-label">Circle</span>
                  <span class="const-score-placeholder">2</span>
                </div>
                <div class="const-praxis-item">
                  <span class="item-number">2.</span>
                  <input type="text" class="const-input" />
                  <span class="const-shape-label">Diamond</span>
                  <span class="const-score-placeholder">3</span>
                </div>
                <div class="const-praxis-item">
                  <span class="item-number">3.</span>
                  <input type="text" class="const-input" />
                  <span class="const-shape-label">Rectangle</span>
                  <span class="const-score-placeholder">2</span>
                </div>
                <div class="const-praxis-item">
                  <span class="item-number">4.</span>
                  <input type="text" class="const-input" />
                  <span class="const-shape-label">Cube</span>
                  <span class="const-score-placeholder">4</span>
                </div>
              </div>
            </div>
          </div>
        </ScoreSection>

        <ScoreSection 
          taskName="WORD LIST MEMORY TASK" 
          :isDisabled="true"
        >
          <ScoreRow label="Score:" :score="0" />
        </ScoreSection>

        <ScoreSection 
          taskName="MATTIS" 
          :isDisabled="true"
        >
          <ScoreRow label="Score:" :score="0" />
        </ScoreSection>
      </div>

      <ScoreSection 
        taskName="Clock Drawing" 
        route="/clock-drawing"
        :currentRoute="currentRoute"
      >
        <ScoreRow label="Score:" :score="clockDrawingScore" />
      </ScoreSection>

      <ScoreSection 
        taskName="Verbal Fluency, Supermarket" 
        route="/verbal-fluency/supermarket/transcription"
        :currentRoute="currentRoute"
        :commentCount="supermarketQa.commentCount"
        :openRequestCount="supermarketQa.openRequestCount"
        :qaClickableStatus="true"
        qaStatusLabel="Comments / Requests"
        @qa-action="openQaWorkspace('supermarket')"
      >
        <ScoreRow label="Total Correct:" :score="supermarketCorrect" />
        <ScoreRow label="Total Incorrect:" :score="supermarketIncorrect" />
        <ScoreRow label="Total Repetitions:" :score="supermarketRepetitions" />
        <div v-if="isQaOpen('supermarket')" class="qa-workspace inline-task-qa">
          <div class="qa-columns">
            <div class="qa-column qa-column-left">
              <div class="qa-subtitle">Item-level comments</div>
              <div v-if="getQaThreadsForTask('supermarket').length === 0" class="qa-empty">No item-level comments yet for this task.</div>
              <div v-else class="qa-item-list">
                <div v-for="thread in getQaThreadsForTask('supermarket')" :key="thread.item.key" class="qa-item">
                  <div class="qa-item-meta">
                    <span class="qa-word">{{ thread.item.word || '—' }}</span>
                    <span class="qa-index">#{{ thread.item.entryIndex + 1 }}</span>
                    <span v-if="thread.item.comment.isRequest" class="qa-chip request">Request</span>
                    <span v-else class="qa-chip comment">Comment</span>
                    <span v-if="thread.item.comment.isRequest && !thread.item.comment.resolved" class="qa-chip open">Open</span>
                    <span v-if="thread.item.comment.isRequest && thread.item.comment.resolved" class="qa-chip resolved">{{ thread.item.comment.resolvedAction || 'Resolved' }}</span>
                  </div>
                  <div class="qa-comment-line">
                    <strong>{{ thread.item.comment.author }}</strong>
                    <span class="qa-time">{{ thread.item.comment.time }}</span>
                  </div>
                  <div class="qa-text">{{ thread.item.comment.text }}</div>
                  <div v-if="thread.item.comment.isRequest" class="qa-request-marks">
                    <span class="mark-chip">Was: {{ thread.item.comment.currentMark || '—' }}</span>
                    <span class="mark-chip suggested">Suggested: {{ thread.item.comment.suggestedMark || '—' }}</span>
                  </div>
                  <div v-if="thread.item.comment.isRequest && !thread.item.comment.resolved" class="qa-request-actions">
                    <button class="accept-btn" @click="acceptQaRequest(thread.item)">Accept</button>
                    <button class="reject-btn" @click="rejectQaRequest(thread.item)">Reject</button>
                  </div>
                  <div v-else class="qa-request-launch">
                    <button class="request-change-btn" @click="toggleQaRequestComposer(thread.item)">
                      {{ qaRequestDrafts[thread.item.key]?.open ? 'Cancel request' : 'Request change' }}
                    </button>
                  </div>
                  <div v-if="qaRequestDrafts[thread.item.key]?.open" class="qa-request-compose">
                    <div class="qa-request-marks-picker">
                      <button
                        v-for="mark in ['c','i','r','q']"
                        :key="`${thread.item.key}_${mark}`"
                        class="qa-mark-option"
                        :class="{ active: qaRequestDrafts[thread.item.key]?.suggestedMark === mark }"
                        @click="setQaSuggestedMark(thread.item, mark)"
                      >
                        {{ mark.toUpperCase() }}
                      </button>
                    </div>
                    <textarea
                      v-model="qaRequestDrafts[thread.item.key].reason"
                      rows="2"
                      class="qa-reply-input"
                      placeholder="Reason for requested change..."
                    ></textarea>
                    <button
                      class="request-change-btn submit"
                      :disabled="!canSubmitQaRequest(thread.item)"
                      @click="postQaRequest(thread.item)"
                    >
                      Submit request
                    </button>
                  </div>
                  <div v-for="reply in thread.replies" :key="`${thread.item.key}_${reply.id}`" class="qa-reply-thread-item">
                    <div class="qa-comment-line">
                      <strong>{{ reply.author }}</strong>
                      <span class="qa-time">{{ reply.time }}</span>
                    </div>
                    <div class="qa-text">{{ reply.text }}</div>
                  </div>
                  <div class="qa-reply-row">
                    <textarea
                      v-model="qaReplyDrafts[thread.item.key]"
                      rows="2"
                      class="qa-reply-input"
                      placeholder="Reply to this item..."
                    ></textarea>
                    <button
                      class="qa-reply-submit"
                      :disabled="!qaReplyDrafts[thread.item.key] || !qaReplyDrafts[thread.item.key].trim()"
                      @click="postQaReply(thread.item)"
                    >
                      Reply
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="qa-column qa-column-right">
              <div class="qa-task-comments">
                <div class="qa-subtitle">Task-level comments</div>
                <div v-if="qaTaskCommentsLoading.supermarket" class="qa-empty">Loading task comments...</div>
                <div v-else-if="qaTaskCommentsError.supermarket" class="qa-empty">{{ qaTaskCommentsError.supermarket }}</div>
                <div v-else-if="getTaskCommentThreads('supermarket').length === 0" class="qa-empty">No task-level comments yet.</div>
                <div v-else class="qa-task-comment-list">
                  <div v-for="thread in getTaskCommentThreads('supermarket')" :key="thread.comment.id" class="qa-task-comment">
                    <div class="qa-comment-line">
                      <strong>{{ thread.comment.author }}</strong>
                      <span class="qa-time">{{ thread.comment.time }}</span>
                    </div>
                    <div class="qa-text">{{ thread.comment.text }}</div>
                    <div v-for="reply in thread.replies" :key="reply.id" class="qa-reply-thread-item">
                      <div class="qa-comment-line">
                        <strong>{{ reply.author }}</strong>
                        <span class="qa-time">{{ reply.time }}</span>
                      </div>
                      <div class="qa-text">{{ reply.text }}</div>
                    </div>
                    <div class="qa-reply-row">
                      <textarea
                        v-model="qaTaskReplyDrafts[thread.comment.id]"
                        rows="2"
                        class="qa-reply-input"
                        placeholder="Reply to task comment..."
                      ></textarea>
                      <button
                        class="qa-reply-submit"
                        :disabled="!qaTaskReplyDrafts[thread.comment.id] || !qaTaskReplyDrafts[thread.comment.id].trim()"
                        @click="postTaskComment('supermarket', qaTaskReplyDrafts[thread.comment.id], thread.comment.id)"
                      >
                        Reply
                      </button>
                    </div>
                  </div>
                </div>
                <div class="qa-reply-row">
                  <textarea
                    v-model="qaTaskCommentDrafts.supermarket"
                    rows="2"
                    class="qa-reply-input"
                    placeholder="Add task-level comment..."
                  ></textarea>
                  <button
                    class="qa-reply-submit"
                    :disabled="!qaTaskCommentDrafts.supermarket || !qaTaskCommentDrafts.supermarket.trim()"
                    @click="postTaskComment('supermarket', qaTaskCommentDrafts.supermarket)"
                  >
                    Post
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ScoreSection>

      <ScoreSection 
        taskName="Verbal Fluency, Letter F" 
        route="/verbal-fluency/letter-f/transcription"
        :currentRoute="currentRoute"
        :commentCount="letterFQa.commentCount"
        :openRequestCount="letterFQa.openRequestCount"
        :qaClickableStatus="true"
        qaStatusLabel="Comments / Requests"
        @qa-action="openQaWorkspace('letterF')"
      >
        <ScoreRow label="Total Correct:" :score="letterFCorrect" />
        <ScoreRow label="Total Incorrect:" :score="letterFIncorrect" />
        <ScoreRow label="Total Repetitions:" :score="letterFRepetitions" />
        <div v-if="isQaOpen('letterF')" class="qa-workspace inline-task-qa">
          <div class="qa-columns">
            <div class="qa-column qa-column-left">
              <div class="qa-subtitle">Item-level comments</div>
              <div v-if="getQaThreadsForTask('letterF').length === 0" class="qa-empty">No item-level comments yet for this task.</div>
              <div v-else class="qa-item-list">
                <div v-for="thread in getQaThreadsForTask('letterF')" :key="thread.item.key" class="qa-item">
                  <div class="qa-item-meta">
                    <span class="qa-word">{{ thread.item.word || '—' }}</span>
                    <span class="qa-index">#{{ thread.item.entryIndex + 1 }}</span>
                    <span v-if="thread.item.comment.isRequest" class="qa-chip request">Request</span>
                    <span v-else class="qa-chip comment">Comment</span>
                    <span v-if="thread.item.comment.isRequest && !thread.item.comment.resolved" class="qa-chip open">Open</span>
                    <span v-if="thread.item.comment.isRequest && thread.item.comment.resolved" class="qa-chip resolved">{{ thread.item.comment.resolvedAction || 'Resolved' }}</span>
                  </div>
                  <div class="qa-comment-line">
                    <strong>{{ thread.item.comment.author }}</strong>
                    <span class="qa-time">{{ thread.item.comment.time }}</span>
                  </div>
                  <div class="qa-text">{{ thread.item.comment.text }}</div>
                  <div v-if="thread.item.comment.isRequest" class="qa-request-marks">
                    <span class="mark-chip">Was: {{ thread.item.comment.currentMark || '—' }}</span>
                    <span class="mark-chip suggested">Suggested: {{ thread.item.comment.suggestedMark || '—' }}</span>
                  </div>
                  <div v-if="thread.item.comment.isRequest && !thread.item.comment.resolved" class="qa-request-actions">
                    <button class="accept-btn" @click="acceptQaRequest(thread.item)">Accept</button>
                    <button class="reject-btn" @click="rejectQaRequest(thread.item)">Reject</button>
                  </div>
                  <div v-else class="qa-request-launch">
                    <button class="request-change-btn" @click="toggleQaRequestComposer(thread.item)">
                      {{ qaRequestDrafts[thread.item.key]?.open ? 'Cancel request' : 'Request change' }}
                    </button>
                  </div>
                  <div v-if="qaRequestDrafts[thread.item.key]?.open" class="qa-request-compose">
                    <div class="qa-request-marks-picker">
                      <button
                        v-for="mark in ['c','i','r','q']"
                        :key="`${thread.item.key}_${mark}`"
                        class="qa-mark-option"
                        :class="{ active: qaRequestDrafts[thread.item.key]?.suggestedMark === mark }"
                        @click="setQaSuggestedMark(thread.item, mark)"
                      >
                        {{ mark.toUpperCase() }}
                      </button>
                    </div>
                    <textarea
                      v-model="qaRequestDrafts[thread.item.key].reason"
                      rows="2"
                      class="qa-reply-input"
                      placeholder="Reason for requested change..."
                    ></textarea>
                    <button
                      class="request-change-btn submit"
                      :disabled="!canSubmitQaRequest(thread.item)"
                      @click="postQaRequest(thread.item)"
                    >
                      Submit request
                    </button>
                  </div>
                  <div v-for="reply in thread.replies" :key="`${thread.item.key}_${reply.id}`" class="qa-reply-thread-item">
                    <div class="qa-comment-line">
                      <strong>{{ reply.author }}</strong>
                      <span class="qa-time">{{ reply.time }}</span>
                    </div>
                    <div class="qa-text">{{ reply.text }}</div>
                  </div>
                  <div class="qa-reply-row">
                    <textarea
                      v-model="qaReplyDrafts[thread.item.key]"
                      rows="2"
                      class="qa-reply-input"
                      placeholder="Reply to this item..."
                    ></textarea>
                    <button
                      class="qa-reply-submit"
                      :disabled="!qaReplyDrafts[thread.item.key] || !qaReplyDrafts[thread.item.key].trim()"
                      @click="postQaReply(thread.item)"
                    >
                      Reply
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="qa-column qa-column-right">
              <div class="qa-task-comments">
                <div class="qa-subtitle">Task-level comments</div>
                <div v-if="qaTaskCommentsLoading.letterF" class="qa-empty">Loading task comments...</div>
                <div v-else-if="qaTaskCommentsError.letterF" class="qa-empty">{{ qaTaskCommentsError.letterF }}</div>
                <div v-else-if="getTaskCommentThreads('letterF').length === 0" class="qa-empty">No task-level comments yet.</div>
                <div v-else class="qa-task-comment-list">
                  <div v-for="thread in getTaskCommentThreads('letterF')" :key="thread.comment.id" class="qa-task-comment">
                    <div class="qa-comment-line">
                      <strong>{{ thread.comment.author }}</strong>
                      <span class="qa-time">{{ thread.comment.time }}</span>
                    </div>
                    <div class="qa-text">{{ thread.comment.text }}</div>
                    <div v-for="reply in thread.replies" :key="reply.id" class="qa-reply-thread-item">
                      <div class="qa-comment-line">
                        <strong>{{ reply.author }}</strong>
                        <span class="qa-time">{{ reply.time }}</span>
                      </div>
                      <div class="qa-text">{{ reply.text }}</div>
                    </div>
                    <div class="qa-reply-row">
                      <textarea
                        v-model="qaTaskReplyDrafts[thread.comment.id]"
                        rows="2"
                        class="qa-reply-input"
                        placeholder="Reply to task comment..."
                      ></textarea>
                      <button
                        class="qa-reply-submit"
                        :disabled="!qaTaskReplyDrafts[thread.comment.id] || !qaTaskReplyDrafts[thread.comment.id].trim()"
                        @click="postTaskComment('letterF', qaTaskReplyDrafts[thread.comment.id], thread.comment.id)"
                      >
                        Reply
                      </button>
                    </div>
                  </div>
                </div>
                <div class="qa-reply-row">
                  <textarea
                    v-model="qaTaskCommentDrafts.letterF"
                    rows="2"
                    class="qa-reply-input"
                    placeholder="Add task-level comment..."
                  ></textarea>
                  <button
                    class="qa-reply-submit"
                    :disabled="!qaTaskCommentDrafts.letterF || !qaTaskCommentDrafts.letterF.trim()"
                    @click="postTaskComment('letterF', qaTaskCommentDrafts.letterF)"
                  >
                    Post
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ScoreSection>

      <ScoreSection 
        taskName="CASI" 
        route="/CASI"
        :currentRoute="currentRoute"
      >
        <ScoreRow label="Attention Score:" :score="casiATT" />
        <ScoreRow label="Mental Manipulation/Concentration Score:" :score="casiMMC" />
        <ScoreRow label="Orientation Score:" :score="casiORI" />
        <ScoreRow label="Long-term Memory Score:" :score="casiLTM" />
        <ScoreRow label="Short-term Memory Score:" :score="casiSTM" />
        <ScoreRow label="Language Score:" :score="casiLANG" />
        <ScoreRow label="Visual Construction Score:" :score="casiDRAW" />
        <ScoreRow label="List-generating Fluency Score:" :score="casiFLU" />
        <ScoreRow label="Abstraction and Judgment Score:" :score="casiATAJ" />
        <ScoreRow label="Total Score:" :score="totalScore" class="total-score"/>
      </ScoreSection>
      <div class="toggle-container">
        <span class="toggle-label">Show advanced tasks</span>
        <button class="toggle-btn" :class="{ 'active': showAdvancedTasks }" @click="showAdvancedTasks = !showAdvancedTasks">
          <span class="toggle-switch"></span>
        </button>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import ScoreSection from './ScoreSection.vue';
import ScoreRow from './ScoreRow.vue';
import CASIController from '../controllers/CASIController';
import { getSubjectData, setSubjectData } from '../utils/storage';
import { eventBus } from '../utils/eventBus';
import ACTApiService from '../services/ACTApiService.js';

export default {
  components: {
    ScoreSection,
    ScoreRow
  },
  data() {
    return {
      controller: new CASIController(),
      jsonData: {},
      clockDrawingScore: 0,
      letterFCorrect: 0,
      letterFIncorrect: 0,
      letterFRepetitions: 0,
      supermarketCorrect: 0,
      supermarketIncorrect: 0,
      supermarketRepetitions: 0,
      totalScore: 0,
      casiATT: 0,
      casiMMC: 0,
      casiORI: 0,
      casiLTM: 0,
      casiSTM: 0,
      casiLANG: 0,
      casiDRAW: 0,
      casiFLU: 0,
      casiATAJ: 0,
      charId: '',
      todayDate: '',
      interviewerName: '',
      qaOpenPanels: {
        supermarket: false,
        letterF: false
      },
      qaReplyDrafts: {},
      qaRequestDrafts: {},
      qaTaskCommentDrafts: {
        supermarket: '',
        letterF: ''
      },
      qaTaskReplyDrafts: {},
      qaTaskCommentsByTask: {
        supermarket: [],
        letterF: []
      },
      qaTaskCommentsLoading: {
        supermarket: false,
        letterF: false
      },
      qaTaskCommentsError: {
        supermarket: '',
        letterF: ''
      },
      actApiService: new ACTApiService(),
      isResizing: false,
      startX: 0,
      startWidth: 0,
      showAdvancedTasks: false,
    };
  },
  computed: {
    currentRoute() {
      return this.$route.path;
    },
    supermarketQa() {
      return this.getQaStatusForTaskData(this.jsonData?.supermarketData || this.jsonData?.verbalFluencySupermarketData);
    },
    letterFQa() {
      return this.getQaStatusForTaskData(this.jsonData?.letterFData || this.jsonData?.verbalFluencyLetterFData);
    }
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.loadAllData();
      }
    }
  },
  async mounted() {
    await this.loadData();
    this.calculateScores();
    this.loadAllData();
    this.charId = localStorage.getItem('subjectId') || '';
    this.todayDate = new Date().toLocaleDateString();
    this.resolveCurrentUser();
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    panelWidth: {
      type: Number,
      default: 775,
    },
    ...['totalScore', 'casiATT', 'casiMMC', 'casiORI', 'casiLTM', 'casiSTM', 'casiLANG', 'casiDRAW', 'casiFLU', 'casiATAJ'].reduce((acc, key) => {
      acc[key] = { type: Number, default: 0 };
      return acc;
    }, {})

  },
  methods: {
    closePage() {
      this.$emit('close');
    },
    async loadData() {
      await this.controller.loadData();
    },
    calculateScores() {
      this.controller.calculateScores();
      this.updateScores();
    },
    updateScores() {
      this.totalScore = this.controller.totalScore || 0;
      this.casiATT = this.controller.casiATT || 0;
      this.casiMMC = this.controller.casiMMC || 0;
      this.casiORI = this.controller.casiORI || 0;
      this.casiLTM = this.controller.casiLTM || 0;
      this.casiSTM = this.controller.casiSTM || 0;
      this.casiLANG = this.controller.casiLANG || 0;
      this.casiDRAW = this.controller.casiDRAW || 0;
      this.casiFLU = this.controller.casiFLU || 0;
      this.casiATAJ = this.controller.casiATAJ || 0;
    },
    loadAllData() {
      try {
        const subjectId = localStorage.getItem('currentSubjectId') || localStorage.getItem('subjectId');
        if (!subjectId) {
          console.error('No subject ID found');
          return;
        }
        
        // Get all subject data
        const allSubjectData = getSubjectData(subjectId);
        
        // Store the full data
        this.jsonData = allSubjectData;
        
        // Extract Clock Drawing score
        this.extractClockDrawingScore(allSubjectData);
        
        // Extract Letter F data
        this.extractLetterFData(allSubjectData);
        
        // Extract Supermarket data
        this.extractSupermarketData(allSubjectData);
        
        // Force a refresh of the component
        this.$forceUpdate();
      } catch (error) {
        console.error('Error loading subject data:', error);
      }
    },
    extractClockDrawingScore(data) {
      // Try to get Clock Drawing score from multiple possible locations
      if (data.clockDrawingData && data.clockDrawingData.clockDrawingScore) {
        this.clockDrawingScore = parseInt(data.clockDrawingData.clockDrawingScore) || 0;
      } else if (data.clockDrawingData && data.clockDrawingData.scoringNotes) {
        this.clockDrawingScore = parseInt(data.clockDrawingData.scoringNotes) || 0;
      } else {
        this.clockDrawingScore = 0;
      }
    },
    extractLetterFData(data) {
      // Try to get Letter F data from multiple possible locations
      let entrySummary = null;
      
      if (data.letterFData && data.letterFData.entrySummary) {
        entrySummary = data.letterFData.entrySummary;
      } else if (data.verbalFluencyLetterFData && data.verbalFluencyLetterFData.entrySummary) {
        entrySummary = data.verbalFluencyLetterFData.entrySummary;
      }
      
      if (entrySummary) {
        this.letterFCorrect = entrySummary.c || 0;
        this.letterFIncorrect = (entrySummary.i || 0) + (entrySummary.ir || 0);
        this.letterFRepetitions = (entrySummary.r || 0) + (entrySummary.ir || 0);
      } else {
        // Default to 0
        this.letterFCorrect = 0;
        this.letterFIncorrect = 0;
        this.letterFRepetitions = 0;
      }
    },
    extractSupermarketData(data) {
      // Try to get Supermarket data from multiple possible locations
      let entrySummary = null;
      
      if (data.supermarketData && data.supermarketData.entrySummary) {
        entrySummary = data.supermarketData.entrySummary;
      } else if (data.verbalFluencySupermarketData && data.verbalFluencySupermarketData.entrySummary) {
        entrySummary = data.verbalFluencySupermarketData.entrySummary;
      }
      
      if (entrySummary) {
        this.supermarketCorrect = entrySummary.c || 0;
        this.supermarketIncorrect = (entrySummary.i || 0) + (entrySummary.ir || 0);
        this.supermarketRepetitions = (entrySummary.r || 0) + (entrySummary.ir || 0);
      } else {
        // Default to 0
        this.supermarketCorrect = 0;
        this.supermarketIncorrect = 0;
        this.supermarketRepetitions = 0;
      }
    },
    getQaStatusForTaskData(taskData) {
      const entries = Array.isArray(taskData?.entries) ? taskData.entries : [];
      if (!entries.length) {
        return { commentCount: 0, openRequestCount: 0 };
      }

      const commentCount = entries.reduce((total, entry) => {
        const itemComments = Array.isArray(entry.itemComments) ? entry.itemComments : [];
        return total + itemComments.length;
      }, 0);

      const unresolvedRequestCount = entries.reduce((total, entry) => {
        const itemComments = Array.isArray(entry.itemComments) ? entry.itemComments : [];
        return total + itemComments.filter((comment) => comment.isRequest && !comment.resolved).length;
      }, 0);

      const pendingRequestCount = entries.reduce(
        (total, entry) => total + (entry.pendingRequest ? 1 : 0),
        0
      );

      return {
        commentCount,
        openRequestCount: Math.max(unresolvedRequestCount, pendingRequestCount)
      };
    },
    getTaskStorageKey(taskKey) {
      return taskKey === 'letterF' ? 'verbalFluencyLetterFData' : 'verbalFluencySupermarketData';
    },
    getTaskDataByKey(taskKey) {
      return taskKey === 'letterF'
        ? (this.jsonData?.letterFData || this.jsonData?.verbalFluencyLetterFData)
        : (this.jsonData?.supermarketData || this.jsonData?.verbalFluencySupermarketData);
    },
    getTaskTypeCandidates(taskKey) {
      if (taskKey === 'letterF') {
        return [
          'Verbal Fluency - Letter F',
          'Verbal Fluency - Letter F - Interview',
          'Verbal Fluency - Letter F - Transcription'
        ];
      }
      return [
        'Verbal Fluency - Supermarket',
        'Verbal Fluency - Supermarket - Interview',
        'Verbal Fluency - Supermarket - Transcription'
      ];
    },
    getTaskLogId(taskKey, taskType) {
      const visitId = localStorage.getItem('visitId');
      if (!visitId) return null;
      return `${visitId}|TASK|${taskType}`;
    },
    isQaOpen(taskKey) {
      return !!this.qaOpenPanels[taskKey];
    },
    openQaWorkspace(taskKey) {
      const nextOpen = !this.qaOpenPanels[taskKey];
      this.qaOpenPanels = {
        ...this.qaOpenPanels,
        [taskKey]: nextOpen
      };
      if (nextOpen) {
        this.loadTaskComments(taskKey);
      }
    },
    getQaItemsForTask(taskKey) {
      const taskData = this.getTaskDataByKey(taskKey);
      const entries = Array.isArray(taskData?.entries) ? taskData.entries : [];
      const items = [];

      entries.forEach((entry, entryIndex) => {
        const itemComments = Array.isArray(entry.itemComments) ? entry.itemComments : [];
        itemComments.forEach((comment, commentIndex) => {
          items.push({
            key: `${taskKey}_${entry.entryId || entryIndex}_${comment.id || commentIndex}`,
            taskKey,
            entry,
            entryIndex,
            word: entry.enteredWord || entry.word || '',
            comment
          });
        });
      });

      return items;
    },
    getCommentParentId(comment) {
      return comment.parentCommentId || comment.parentId || null;
    },
    getQaThreadsForTask(taskKey) {
      const items = this.getQaItemsForTask(taskKey);
      // Treat change requests as first-class thread items even when created from a comment.
      const topLevel = items.filter((item) => item.comment.isRequest || !this.getCommentParentId(item.comment));

      return topLevel.map((item) => ({
        item,
        replies: items
          .filter((candidate) => this.getCommentParentId(candidate.comment) === item.comment.id && !candidate.comment.isRequest)
          .map((candidate) => candidate.comment)
      }));
    },
    getTaskLevelComments(taskKey) {
      return this.qaTaskCommentsByTask[taskKey] || [];
    },
    getTaskCommentThreads(taskKey) {
      const comments = this.getTaskLevelComments(taskKey);
      const topLevel = comments.filter((c) => !this.getCommentParentId(c));
      return topLevel.map((comment) => ({
        comment,
        replies: comments.filter((r) => this.getCommentParentId(r) === comment.id)
      }));
    },
    getCurrentUserInitials() {
      const name = this.interviewerName || 'Interviewer';
      return name
        .split(' ')
        .map((p) => p.charAt(0))
        .join('')
        .toUpperCase()
        .slice(0, 3);
    },
    saveQaTaskData(taskKey, taskData) {
      const subjectId = localStorage.getItem('currentSubjectId') || localStorage.getItem('subjectId');
      if (!subjectId || !taskData) return;
      setSubjectData(subjectId, this.getTaskStorageKey(taskKey), taskData);
      this.loadAllData();
    },
    toggleQaRequestComposer(item) {
      const existing = this.qaRequestDrafts[item.key] || {};
      this.qaRequestDrafts = {
        ...this.qaRequestDrafts,
        [item.key]: {
          open: !existing.open,
          suggestedMark: existing.suggestedMark || null,
          reason: existing.reason || ''
        }
      };
    },
    setQaSuggestedMark(item, mark) {
      const existing = this.qaRequestDrafts[item.key] || { open: true, suggestedMark: null, reason: '' };
      this.qaRequestDrafts = {
        ...this.qaRequestDrafts,
        [item.key]: {
          ...existing,
          open: true,
          suggestedMark: existing.suggestedMark === mark ? null : mark
        }
      };
    },
    canSubmitQaRequest(item) {
      const draft = this.qaRequestDrafts[item.key];
      return !!(draft && draft.suggestedMark && draft.reason && draft.reason.trim());
    },
    postQaRequest(item) {
      const draft = this.qaRequestDrafts[item.key];
      if (!this.canSubmitQaRequest(item)) return;

      const now = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      if (!Array.isArray(item.entry.itemComments)) item.entry.itemComments = [];

      item.entry.itemComments.push({
        id: `req_${Date.now()}`,
        author: this.interviewerName || 'Interviewer',
        initials: this.getCurrentUserInitials(),
        avatarColor: '#317391',
        time: now,
        isRequest: true,
        resolved: false,
        parentId: item.comment.id,
        entryIndex: item.entryIndex,
        word: item.word,
        currentMark: item.entry.selectedAnswer ? item.entry.selectedAnswer.toUpperCase() : '—',
        suggestedMark: draft.suggestedMark.toUpperCase(),
        text: draft.reason.trim()
      });
      item.entry.pendingRequest = true;
      item.entry.commentCount = item.entry.itemComments.length;
      this.qaRequestDrafts = {
        ...this.qaRequestDrafts,
        [item.key]: { open: false, suggestedMark: null, reason: '' }
      };
      this.saveQaTaskData(item.taskKey, this.getTaskDataByKey(item.taskKey));
    },
    postQaReply(item) {
      const text = (this.qaReplyDrafts[item.key] || '').trim();
      if (!text) return;

      const now = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      if (!Array.isArray(item.entry.itemComments)) item.entry.itemComments = [];

      item.entry.itemComments.push({
        id: `qa_${Date.now()}`,
        author: this.interviewerName || 'Interviewer',
        initials: this.getCurrentUserInitials(),
        avatarColor: '#317391',
        time: now,
        isRequest: false,
        parentId: item.comment.id,
        text
      });
      item.entry.commentCount = item.entry.itemComments.length;
      this.qaReplyDrafts[item.key] = '';
      this.saveQaTaskData(item.taskKey, this.getTaskDataByKey(item.taskKey));
    },
    postTaskComment(taskKey, text, parentId = null) {
      const cleanText = (text || '').trim();
      if (!cleanText) return;
      const taskType = this.getTaskTypeCandidates(taskKey)[0];
      const logId = this.getTaskLogId(taskKey, taskType);
      if (!logId) {
        this.qaTaskCommentsError = {
          ...this.qaTaskCommentsError,
          [taskKey]: 'Missing visit ID. Cannot post task comments.'
        };
        return;
      }

      const userData = JSON.stringify({
        username: this.interviewerName || 'Interviewer',
        timestamp: new Date().toISOString()
      });

      this.actApiService
        .createComment(logId, parentId, null, cleanText, userData)
        .then(() => this.loadTaskComments(taskKey))
        .catch((error) => {
          this.qaTaskCommentsError = {
            ...this.qaTaskCommentsError,
            [taskKey]: `Failed to post comment: ${error.message}`
          };
        });

      if (parentId) {
        this.qaTaskReplyDrafts = { ...this.qaTaskReplyDrafts, [parentId]: '' };
      } else {
        this.qaTaskCommentDrafts = { ...this.qaTaskCommentDrafts, [taskKey]: '' };
      }
    },
    async loadTaskComments(taskKey) {
      const visitId = localStorage.getItem('visitId');
      if (!visitId) {
        this.qaTaskCommentsError = {
          ...this.qaTaskCommentsError,
          [taskKey]: 'Missing visit ID. Cannot load task comments.'
        };
        this.qaTaskCommentsByTask = {
          ...this.qaTaskCommentsByTask,
          [taskKey]: []
        };
        return;
      }

      this.qaTaskCommentsLoading = { ...this.qaTaskCommentsLoading, [taskKey]: true };
      this.qaTaskCommentsError = { ...this.qaTaskCommentsError, [taskKey]: '' };

      try {
        let comments = [];
        for (const taskType of this.getTaskTypeCandidates(taskKey)) {
          const candidateLogId = this.getTaskLogId(taskKey, taskType);
          if (!candidateLogId) continue;
          const result = await this.actApiService.getCommentsForLog(candidateLogId, false);
          if (Array.isArray(result) && result.length > 0) {
            comments = result;
            break;
          }
        }
        const getAuthor = (rawUserData) => {
          if (!rawUserData) return 'Unknown User';
          if (typeof rawUserData === 'string') {
            try {
              const parsed = JSON.parse(rawUserData);
              return parsed?.username || parsed?.name || 'Unknown User';
            } catch {
              return 'Unknown User';
            }
          }
          return rawUserData.username || rawUserData.name || 'Unknown User';
        };
        const normalized = comments.map((c) => ({
          id: c.CommentId,
          parentId: c.ParentCommentId || null,
          author: getAuthor(c.UserData),
          time: c.DateTimeCreated ? new Date(c.DateTimeCreated).toLocaleString() : '',
          text: c.CommentText || ''
        }));
        this.qaTaskCommentsByTask = {
          ...this.qaTaskCommentsByTask,
          [taskKey]: normalized
        };
      } catch (error) {
        this.qaTaskCommentsError = {
          ...this.qaTaskCommentsError,
          [taskKey]: `Failed to load task comments: ${error.message}`
        };
      } finally {
        this.qaTaskCommentsLoading = { ...this.qaTaskCommentsLoading, [taskKey]: false };
      }
    },
    acceptQaRequest(item) {
      const comment = item.comment;
      comment.resolved = true;
      comment.resolvedAction = 'Accepted';
      comment.resolvedBy = this.interviewerName || 'Interviewer';

      if (item.entry) {
        if (comment.suggestedMark) {
          const prev = item.entry.selectedAnswer;
          item.entry.selectedAnswer = comment.suggestedMark.toLowerCase();
          if (!Array.isArray(item.entry.changeLog)) item.entry.changeLog = [];
          item.entry.changeLog.push({
            id: `h_${Date.now()}`,
            actor: this.interviewerName || 'Interviewer',
            actorColor: '#317391',
            from: prev ? prev.toUpperCase() : '—',
            to: comment.suggestedMark,
            reason: `Accepted request from ${comment.author}`,
            time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
          });
        }
        item.entry.pendingRequest = false;
      }

      this.saveQaTaskData(item.taskKey, this.getTaskDataByKey(item.taskKey));
    },
    rejectQaRequest(item) {
      const comment = item.comment;
      comment.resolved = true;
      comment.resolvedAction = 'Rejected';
      comment.resolvedBy = this.interviewerName || 'Interviewer';
      if (item.entry) item.entry.pendingRequest = false;
      this.saveQaTaskData(item.taskKey, this.getTaskDataByKey(item.taskKey));
    },
    async resolveCurrentUser() {
      try {
        const { CognitoUserPool } = await import('amazon-cognito-identity-js');
        const poolData = {
          UserPoolId: 'us-east-2_3novul0pN',
          ClientId: '51v76uda8o5l6niokhg852qnj5'
        };
        const userPool = new CognitoUserPool(poolData);
        const cognitoUser = userPool.getCurrentUser();

        if (!cognitoUser) return;

        cognitoUser.getSession((err, session) => {
          if (err || !session || !session.isValid()) return;
          const idToken = session.getIdToken();
          const payload = idToken.payload || {};
          this.interviewerName = payload['cognito:username'] || payload.username || '';
        });
      } catch (error) {
        console.warn('Unable to resolve current interviewer username', error);
      }
    },
    startResize(e) {
      e.preventDefault();
      this.isResizing = true;
      this.startX = e.clientX;
      this.startWidth = this.panelWidth;

      document.addEventListener('mousemove', this.handleResize);
      document.addEventListener('mouseup', this.stopResize);
    },
    handleResize(e) {
      if (!this.isResizing) return;
      
      const diff = this.startX - e.clientX;
      let newWidth = this.startWidth + diff;
      
      const minWidth = Math.max(775, window.innerWidth * 0.2);
      const maxWidth = window.innerWidth * 0.75;
      newWidth = Math.max(minWidth, Math.min(maxWidth, newWidth));
      
      this.$emit('resize', newWidth);
    },
    stopResize() {
      this.isResizing = false;
      document.removeEventListener('mousemove', this.handleResize);
      document.removeEventListener('mouseup', this.stopResize);
    }
  },
  created() {
    // Listen for data-saved events
    this.unsubscribe = eventBus.on('data-saved', () => {
      // Refresh data when any task data is saved
      this.loadAllData();
    });
    
    // Refresh score data every 2 seconds when panel is open
    this.refreshInterval = setInterval(() => {
      if (this.isOpen) {
        this.loadAllData();
      }
    }, 2000);
  },
  beforeUnmount() {
    // Clean up event listener and interval
    if (this.unsubscribe) {
      this.unsubscribe();
    }
    
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }
};
</script>

<style scoped>
.scoring-panel {
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  background-color: white;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.5);
  overflow-y: auto;
  z-index: 1000;
  display: flex;
}

.resize-handle {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 8px;
  cursor: ew-resize;
  z-index: 10;
  background-color: transparent;
  transition: background-color 0.2s;
}

.resize-handle:hover {
  background-color: rgba(57, 134, 168, 0.3);
}

.close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  background-color: white;
  color: #317391;
  border: 2px solid #317391;
  border-radius: 8px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  padding: 5px;
  z-index: 1100;
}

.close-btn:hover {
  background-color: #e0e0e0;
  transform: scale(1.1);
}

.close-btn:focus {
  outline: none;
}

.content {
  padding: 20px;
  padding-left: 24px;
  overflow-y: auto;
  height: calc(100% - 40px);
  flex: 1;
  position: relative;
}

.total-score {
  font-weight: bold;
}

.trails-container {
  display: flex;
  gap: 15px;
  align-items: flex-start;
}

.trails-section {
  flex: 1;
}

.trail-making-layout {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.trail-section {
  flex: 1;
}

.trail-header {
  font-weight: bold;
  margin-bottom: 5px;
  color: #317391;
}

.trail-values {
  margin-bottom: 5px;
}

.trail-scores {
  display: flex;
  gap: 10px;
}

.trail-scores .score-row {
  flex: 1;
  margin-bottom: 5px;
}

.trail-score-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.trail-score-item .score-box {
  background-color: #f0f0f0;
  padding: 5px 10px;
  border-radius: 4px;
  text-align: center;
  min-width: 50px;
  margin-bottom: 5px;
}

.trail-score-item .score-label {
  font-size: 0.875rem;
  color: #666;
  text-align: center;
}

.info-box {
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 15px;
  flex: 0 0 auto;
  min-width: 250px;
}

.info-row {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 8px;
}

.info-row:last-child {
  margin-bottom: 0;
}

.info-label {
  font-size: 0.875rem;
  white-space: nowrap;
  margin-right: 5px;
  color: #333;
}

.info-input-box {
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 5px;
  text-align: center;
  min-width: 30px;
  max-width: 40px;
  font-size: 0.875rem;
}

.info-input-box-wide {
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 5px 10px;
  text-align: left;
  flex: 1;
  font-size: 0.875rem;
}

.slash {
  color: #999;
  padding: 0 2px;
}

.info-value {
  font-size: 0.875rem;
  color: #317391;
  font-weight: 500;
}

.toggle-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin: 15px 0;
}

.toggle-label {
  font-size: 0.9rem;
  color: #374151;
  font-weight: 500;
}

.toggle-btn {
  width: 50px;
  height: 30px;
  background-color: #ccc;
  border: none;
  border-radius: 15px;
  cursor: pointer;
  position: relative;
  transition: background-color 0.3s;
}

.toggle-btn.active {
  background-color: #317391;
}

.toggle-switch {
  display: block;
  width: 24px;
  height: 24px;
  background-color: white;
  border-radius: 50%;
  position: absolute;
  top: 3px;
  left: 3px;
  transition: transform 0.3s;
}

.toggle-btn.active .toggle-switch {
  transform: translateX(20px);
}

.qa-workspace {
  border: 1px solid #d1d5db;
  border-radius: 10px;
  background: #f8fafc;
  padding: 12px;
  margin: 14px 0;
  overflow-x: hidden;
}

.inline-task-qa {
  margin-top: 10px;
}

.qa-columns {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(0, 1fr);
  gap: 14px;
  align-items: start;
  width: 100%;
}

.qa-column {
  min-width: 0;
}

@media (max-width: 1300px) {
  .qa-columns {
    grid-template-columns: 1fr;
  }
}

.qa-workspace-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.qa-workspace-title {
  font-weight: 700;
  color: #1f2937;
}

.qa-workspace-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.qa-tab {
  border: 1px solid #cbd5e1;
  background: white;
  border-radius: 9999px;
  font-size: 12px;
  padding: 4px 10px;
  cursor: pointer;
}

.qa-tab.active {
  background: #dbeafe;
  color: #1d4ed8;
  border-color: #93c5fd;
}

.qa-close {
  border: 1px solid #d1d5db;
  background: white;
  border-radius: 6px;
  padding: 4px 10px;
  cursor: pointer;
}

.qa-empty {
  font-size: 13px;
  color: #6b7280;
  padding: 10px 0;
}

.qa-item-list {
  max-height: 460px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.qa-item {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px;
}

.qa-reply-thread-item {
  margin: 8px 0 8px 14px;
  padding: 8px 10px;
  border-left: 3px solid #bfdbfe;
  background: #f8fbff;
  border-radius: 6px;
}

.qa-item-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: 4px;
}

.qa-word {
  font-weight: 600;
  color: #111827;
}

.qa-index {
  color: #6b7280;
  font-size: 12px;
}

.qa-chip {
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
}

.qa-chip.comment { background: #dbeafe; color: #1d4ed8; }
.qa-chip.request { background: #fef3c7; color: #92400e; }
.qa-chip.open { background: #ffedd5; color: #9a3412; }
.qa-chip.resolved { background: #dcfce7; color: #166534; }

.qa-comment-line {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  margin-bottom: 4px;
}

.qa-time {
  color: #9ca3af;
  font-size: 12px;
}

.qa-text {
  color: #374151;
  font-size: 13px;
  margin-bottom: 6px;
}

.qa-request-marks {
  display: flex;
  gap: 6px;
  margin-bottom: 6px;
}

.qa-request-actions {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}

.accept-btn {
  font-size: 12px;
  font-weight: 600;
  color: #166534;
  background: #dcfce7;
  border: 1px solid #86efac;
  padding: 3px 12px;
  border-radius: 10px;
  cursor: pointer;
}

.accept-btn:hover {
  background: #bbf7d0;
}

.reject-btn {
  font-size: 12px;
  font-weight: 600;
  color: #991b1b;
  background: #fee2e2;
  border: 1px solid #fca5a5;
  padding: 3px 12px;
  border-radius: 10px;
  cursor: pointer;
}

.reject-btn:hover {
  background: #fecaca;
}

.qa-reply-row {
  display: flex;
  gap: 8px;
  align-items: flex-end;
}

.qa-reply-input {
  flex: 1;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 6px 8px;
  font-size: 12px;
  font-family: inherit;
  resize: vertical;
}

.qa-reply-submit {
  border: none;
  background: #4a90e2;
  color: white;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 12px;
  cursor: pointer;
}

.qa-reply-submit:disabled {
  background: #cbd5e1;
  cursor: not-allowed;
}

.qa-request-launch {
  margin-bottom: 8px;
}

.qa-request-compose {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
}

.qa-request-marks-picker {
  display: flex;
  gap: 6px;
}

.qa-mark-option {
  width: 30px;
  height: 30px;
  border: 1px solid #3f8fb2;
  color: #3f8fb2;
  background: white;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.qa-mark-option.active {
  background: #4aa7d0;
  color: white;
  border-color: #357a96;
}

.request-change-btn {
  border: 1px solid #f59e0b;
  color: #92400e;
  background: #fffbeb;
  border-radius: 8px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.request-change-btn.submit {
  align-self: flex-start;
}

.request-change-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.qa-task-comments {
  margin-top: 0;
  padding-top: 0;
}

.qa-subtitle {
  font-size: 13px;
  font-weight: 700;
  color: #334155;
  margin-bottom: 8px;
}

.qa-task-comment-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 10px;
}

.qa-task-comment {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 8px;
}

.const-praxis-content {
  display: flex;
  flex-direction: row;
  gap: 30px;
}

.const-praxis-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.const-praxis-label {
  font-weight: bold;
  margin-bottom: 5px;
}

.const-praxis-items {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.const-praxis-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.item-number {
  font-weight: bold;
}

.const-input {
  background-color: #f0f0f0;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  text-align: center;
  width: 50px;
}

.const-shape-label {
  font-size: 0.75rem;
  color: #666;
  min-width: 60px;
}

.const-score-placeholder {
  background-color: #e0e0e0;
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: bold;
  color: #666;
}
</style>
